import React from 'react';
import { connect } from 'react-redux'

class QuickAlerts extends React.Component {
    render(){
        let { authenticatedUser, tickets, sessions } = this.props
        const session = sessions.find( session => session.userId === authenticatedUser.id )

        let priorityTickets = tickets.filter( ticket => 
            ticket.manage != null &&
            !(Number(ticket.status))
        )
        .filter( ticket => 
            ticket.manage.userId === authenticatedUser.id ||
            ticket.manage.supportDeskId === session.supportDeskId

        )
        
        return priorityTickets.length
            ?   <div className="quickAlerts">
                    <p className="count">{ priorityTickets.length } Ticket{priorityTickets.length>1?"s":""}</p>
                    <p>Can only be served by you.</p>
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31.125 16.125C31.125 7.84375 24.4062 1.125 16.125 1.125C7.84375 1.125 1.125 7.84375 1.125 16.125C1.125 24.4062 7.84375 31.125 16.125 31.125C24.4062 31.125 31.125 24.4062 31.125 16.125Z" stroke="var(--red)" stroke-width="2.09451" stroke-miterlimit="10"/>
                        <path d="M15.6765 9.09765L16.125 18.625L16.5726 9.09765C16.5754 9.03674 16.5657 8.97591 16.5442 8.91887C16.5226 8.86184 16.4897 8.80979 16.4474 8.76592C16.405 8.72204 16.3542 8.68727 16.2979 8.66371C16.2417 8.64015 16.1813 8.6283 16.1203 8.6289C16.0601 8.62946 16.0005 8.64216 15.9453 8.66624C15.8901 8.69032 15.8403 8.72527 15.7989 8.76902C15.7574 8.81277 15.7253 8.86442 15.7043 8.92088C15.6832 8.97735 15.6738 9.03746 15.6765 9.09765Z" stroke="var(--red)" stroke-width="2.09451" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.125 24.868C15.816 24.868 15.5139 24.7763 15.257 24.6046C15 24.4329 14.7997 24.1889 14.6815 23.9034C14.5632 23.6179 14.5323 23.3037 14.5926 23.0006C14.6528 22.6975 14.8017 22.4191 15.0202 22.2006C15.2387 21.9821 15.5171 21.8333 15.8202 21.773C16.1233 21.7127 16.4375 21.7436 16.723 21.8619C17.0085 21.9802 17.2525 22.1804 17.4242 22.4374C17.5959 22.6943 17.6875 22.9964 17.6875 23.3055C17.6875 23.7199 17.5229 24.1173 17.2299 24.4103C16.9369 24.7033 16.5394 24.868 16.125 24.868Z" fill="var(--red)"/>
                    </svg>

                </div>
            :   null
    }
}

const mapStateToProps = state => {
    const { auth, tickets, sessions } = state
    return {
        authenticatedUser: auth.authenticatedUser,
        sessions: sessions.sessions,
        activeTicketId: tickets.activeTicketId,
        tickets: tickets.tickets,
    }
}

export default connect(mapStateToProps, {})(QuickAlerts);

